module.exports = __webpack_public_path__ + "Flama-ExtraboldItalic.ttf?3316562e66f9eed28bec538927349bed";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-ExtraboldItalic.ttf
// module id = 901
// module chunks = 0